const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,

  current_user: state => state.user.current_user, // 包含当前登录用户的基本信息
  is_system: state => state.user.is_system, // 当前用户角色是否为超级用户
  permissions: state => state.user.permissions, // 当前用户的模块
  menu: state => state.user.menu,
  sub_menu: state => state.user.sub_menu,
  menu_id: state => state.user.menu_id,
  sub_title: state => state.user.sub_title,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,

  permission_routes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,
  errorLogs: state => state.errorLog.logs,
  sysConfig: state => state.sys_config.config
}
export default getters
